import React, {useState, useEffect, useContext, useRef} from "react";
import {Link as ScrollLink} from "react-scroll";
import {SideMenuContext, createOpenMenuAction, createOpenSchemaAction, createOpenSubMenuAction, createOuterIndexAction, createActiveState} from "../../context/SideMenuContext";
import {extractTitleAndSchemaId} from "../../utils/helpers";
import {Tooltip} from "antd";
import {updateUrlWithMethodName} from "../../utils/sideBarUtils";


function SchemaSideMenu({menu}) {
  const [schemaActiveState, setSchemaActiveState] = useState(-1);
  const {state, dispatch} = useContext(SideMenuContext);
  const {outerIndex, openSchema, openMenu, openSubMenu} = state;
  const [schemaId, setSchemaId] = useState();

  const highlightedSchemaElementRef = useRef(null);
  const onClickSchemaActive = (index, title) => {
    updateUrlWithMethodName(title);
    dispatch(createActiveState(-1));

    setTimeout(() => {
      setSchemaActiveState(index);
    }, 10);
  };
  const handleOnClickSchema = (method) =>{
    updateUrlWithMethodName(method);
    setTimeout(()=>{
      dispatch(createOpenSchemaAction(1));
      dispatch(createOpenSubMenuAction(-1));
      dispatch(createActiveState(-1));
    }, 100);
  };

  useEffect(() => {
    const schemas = document.querySelectorAll(".schemas");
    // Intersection observer for Schemas to highlight and expand Schemas on the side menu
    const schemaObserver = new IntersectionObserver(
      (entries) => {
        entries.reverse().forEach((entry) => {
          if (entry.isIntersecting) {
            const schemaIndex = entry.target?.getAttribute("data-index");
            const navIndex = entry.target?.getAttribute("data-open-index");
            dispatch(createOpenSchemaAction(Number(navIndex)));
            dispatch(createOpenMenuAction(-1));
            dispatch(createOpenSubMenuAction(-1));
            setSchemaActiveState(Number(schemaIndex));
            // setActiveState(0);
            const idName =(`schemas${schemaIndex}`);
            dispatch(createActiveState(-1));

            // constidName = `schemas${entry.target?.getAttribute("data-id")}`;
            setSchemaId(idName);
            highlightedSchemaElementRef.current = document.getElementById(idName);
          }
        });
      },
      {threshold: 0.5},
    );

    // Observing the Schemas
    schemas.forEach((schema) => {
      schemaObserver.observe(schema);
    });

    // Cleanup function to unobserve elements when the component unmounts
    return () => {
      schemas.forEach((schema) => {
        schemaObserver.unobserve(schema);
      });
    };
  }, [openMenu]);

  useEffect(() => {
    setTimeout(() => {
      if (highlightedSchemaElementRef.current) {
        highlightedSchemaElementRef.current.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }, 50);
  }, [highlightedSchemaElementRef.current]);
  useEffect(()=>{
    setTimeout(() => {
      highlightedSchemaElementRef.current = document.getElementById(schemaId);
    }, 10);
  }, [schemaId]);

  return (
    <div>
      <ScrollLink
        activeClass="none"
        className="toc-h1 toc-link active-parent"
        onClick={() =>handleOnClickSchema("schemas")}
        to={"schemas"}
        spy={true}
        smooth={false}
        offset={-150}
        duration={0}
      >
        <b> Schemas</b>
      </ScrollLink>
      {openSchema!==-1&&menu.map(({header, subEntities, schemas}, menuIndex) => {
        return (
          <div key={header}>
            {schemas&&schemas.map((item, index) => {
              return (
                <li key={index}>
                  <div className="heading">
                    <div>
                      {true&&
        Object.entries(item).map((entry, index) => {
          const {title, uniqueSchemaId}=extractTitleAndSchemaId(entry);
          return (
            <li key={index} id={`schemas${entry[1]["id"]}`} >
              <ScrollLink
                to={entry[1]["id"]}
                activeClass="none"
                spy={true}
                smooth={false}
                offset={-150}
                duration={0}
                onClick={() =>
                  onClickSchemaActive(entry[1]["id"], title)
                }
                className={
                  schemaActiveState === entry[1]["id"] ?
                    "toc-h4 toc-link side-menu-methods active" :
                    "toc-h4 toc-link side-menu-methods"
                }
              >
                <span
                  className="sidebar-link-text sidebar-item-link"
                  key={index}
                >
                  <Tooltip placement="bottom" title={title}>
                    {title}
                  </Tooltip>

                </span>
              </ScrollLink>
            </li>
          );
        })}
                    </div>
                  </div>
                </li>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default SchemaSideMenu;
